import { PartyData, PartyModel } from 'models/PartyModel';
import { ApiBase } from 'utils/api';


export default class PartyApi {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    }

    all = (type: string) => this.base.axios
        .get(`/api/parties`, {params: {type}});

    search = (s: string, type?: string) => this.base.axios
        .get(`/api/parties/search`, {params: {s, type}})
        .then(res => res.data);

    create = (data: PartyData) => {
        return this.base.axios.post(`/api/parties`, data);
    };

    attach = (parent: string, parentId: number, id: number) => {
        return this.base.axios.put(`/api/parties/${id}/attach/${parent}`, {id: parentId});
    };

    detach = (parent: string, parentId: number, id: number) => {
        return this.base.axios.put(`/api/parties/${id}/detach/${parent}`, {id: parentId});
    };

    update = (data: PartyModel) => {
        return this.base.axios.put(`/api/parties/${data.id}`, data);
    };

    setType = (id: number, type: string) => {
        return this.base.axios.put(`/api/parties/${id}/type`, {type});
    };

    merge = (ids: number[]) => {
        return this.base.axios.post(`/api/parties/merge`, {ids});
    };
}
